import { Card, Divider, Skeleton, Typography } from 'antd';
import {
    FaHotel,
    FaCalendarAlt,
    FaArrowRight,
    FaRegUser,
    FaChild
} from 'react-icons/fa';
import moment from 'moment';

const { Text } = Typography;

const PaymentFareCardTripjack = ({
    loading,
    openRoomDetailsUpdate,
    hotelDetails,
    handleNavigate,
    totalRooms
}) => {

    const totalAdults = hotelDetails?.searchQuery?.roomInfo?.reduce((acc, room) => acc + room?.numberOfAdults, 0);
    const totalChildren = hotelDetails?.searchQuery?.roomInfo?.reduce((acc, room) => acc + room?.numberOfChild, 0);

    return (
        <Skeleton
            paragraph={{ rows: 4, }}
            loading={loading}
            style={{ background: "#fff" }}
            className='p-4 mb-4'
        >
            <Card
                className="card mb-md-2 hotel_confirm_cntr d-md-block d-none"
                loading={loading}
                style={{ padding: "0" }}
            >
                <div className=''>
                    <div className='d-flex align-items-center mb-3'>
                        <div className='border py-1 px-2 rounded mb-1 d-inline-block'>
                            <FaHotel />
                        </div>
                        <p className='room-type mb-0 ms-2 fw-bold text-truncate'>
                            {openRoomDetailsUpdate?.ris?.[0]?.rc}
                        </p>
                    </div>

                    <Divider className='my-2' />

                    <div className="ratings d-flex align-items-center gap-2 mb-2">
                        {/* <FaCalendarAlt /> */}
                        {/* <div className="d-flex align-items-center gap-2">
                            {hotelDetails?.searchQuery?.checkinDate
                                ? moment(hotelDetails?.searchQuery?.checkinDate).format('MMM D, YYYY')
                                : 'N/A'}
                            <FaArrowRight />
                            {hotelDetails?.searchQuery?.checkoutDate
                                ? moment(hotelDetails?.searchQuery?.checkoutDate).format('MMM D, YYYY')
                                : 'N/A'}
                        </div> */}

                        <div className="date-info mb-3 bg-light-primary px-2 py-2 rounded">
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <FaCalendarAlt size={18} className="text-primary" />
                                <span>Check-in: {moment(hotelDetails?.searchQuery?.checkinDate).format("MMM DD, YYYY")}</span>
                            </div>
                            <Divider className="my-2" />
                            <div className="d-flex align-items-center gap-2">
                                <FaCalendarAlt size={18} className="text-primary" />
                                <span>Check-out: {moment(hotelDetails?.searchQuery?.checkoutDate).format("MMM DD, YYYY")}</span>
                            </div>
                        </div>
                    </div>

                    <Divider className='my-2' />

                    <div className='d-flex justify-content-between'>
                        <h6><FaRegUser className="me-2" />{totalAdults} Adults </h6>
                        <h6> <FaChild className="me-2" />{totalChildren} Child{totalChildren > 1 ? 'ren' : ''} </h6>
                    </div>

                    <div className="d-flex justify-content-between mt-2">
                        <h3>{totalRooms} Total Room{totalRooms > 1 ? "s" : ""}</h3>
                    </div>
                    <Divider />

                    <div className='bg-light-primary p-2 rounded'>
                        <div className="d-flex align-items-center justify-content-between pb-1">
                            <Text>Base Fare</Text>
                            <Text><b>₹{Math.round(openRoomDetailsUpdate?.ris?.[0]?.TotalPublishFare)}/-</b></Text>
                        </div>
                        <hr />

                        <div className="d-flex align-items-center justify-content-between mt-1 pb-1">
                            <Text>Total Discount</Text>
                            <Text><b className='text-danger'>₹{Math.round(openRoomDetailsUpdate?.ris?.[0]?.discountAmount)}/-</b></Text>
                        </div>
                        <hr />

                        <div className="d-flex align-items-center justify-content-between mt-1 pb-1">
                            <Text>Price after Discount</Text>
                            <Text><b>₹{Math.round(openRoomDetailsUpdate?.ris?.[0]?.PublishedPriceRoundedOff)}/-</b></Text>
                        </div>
                        <hr />

                        <div className="d-flex align-items-center justify-content-between mt-1">
                            <Text>Taxes & Fees </Text>
                            <Text><b>₹{Math.round(openRoomDetailsUpdate?.ris?.[0]?.ServiceTax)}/-</b></Text>
                        </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-2 mb-3">
                        <p className="text-muted mb-0">Total Price :</p>
                        <p className="mb-0 fw-bold text-success" style={{ fontSize: "1.2rem" }}>
                            ₹{Math.round(openRoomDetailsUpdate?.ris?.[0]?.PublishedPriceRoundedOff + openRoomDetailsUpdate?.ris?.[0]?.ServiceTax)}
                        </p>
                    </div>

                    <button
                        className="btn btn-primary w-100 border-0 fw-bold fs-6 mt-0"
                        style={{
                            borderRadius: "4px",
                            padding: "10px 0",
                        }}
                        onClick={handleNavigate}
                        aria-label="continue"
                    >
                        Book This Now
                    </button>
                </div>
            </Card>
        </Skeleton>
    );
};

export default PaymentFareCardTripjack;